import TagsPage from "@/components/site-settings/TagsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/site-settings/tags")({
  component: TagsPage,
});
